// eslint-disable-next-line import/no-cycle
import store from '@/store';
import router from '@/router';
import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export const mainApi = axios.create({
  baseURL: '/api', // Use relative path instead of environment variable

  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: set the token dynamically
mainApi.interceptors.request.use(
  (config) => {
    const token =
      (store && store.state && store.state.auth && store.state.auth.token) ||
      localStorage.getItem('jwt');

    // Create a new config object to avoid directly mutating the parameter
    const newConfig = { ...config, headers: { ...config.headers } };

    if (token) {
      // Old backend expects raw tokens (no Bearer prefix)
      const tokenValue = token.startsWith('Bearer ') ? token.substring(7) : token;
      newConfig.headers.Authorization = tokenValue;
    }
    return newConfig;
  },
  (error) => Promise.reject(error),
);

mainApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401 && router.currentRoute.value.name !== 'login') {
      return router.push('/auth');
    }
    return Promise.reject(error);
  },
);
